class GenericError extends Error {
  constructor({ message, errorCode, actionCode }, errorData) {
    super(message);
    this.errorData = errorData;
    this.actionCode = actionCode;
    this.code = errorCode;
  }
}

export default GenericError;
